import { render } from "./SearchTeamDropdown.vue?vue&type=template&id=5464743d"
import script from "./SearchTeamDropdown.vue?vue&type=script&lang=js"
export * from "./SearchTeamDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__